const FLOCKTORY_CART_EVENT = 'delikateska_cart';

export const pushFlocktoryCartToDataLayer = (cartItemsCount: number): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: FLOCKTORY_CART_EVENT,
    delikateska_cart_items_count: cartItemsCount,
    delikateska_cart_is_empty: cartItemsCount === 0
  });
};
